import { useQuery } from "@tanstack/react-query";
import { useRef, useEffect } from "react";
import CashierApi from "../utility/CashierApi";

function useDefaultCustomer() {
  console.log("Fetching default customer...");
  const { fetchOnlyData } = CashierApi();

  // Persistent reference to avoid re-renders
  const customerIdRef = useRef(null);

  // Function to manually fetch data
  const fetchDefaultCustomer = async () => {
    if (customerIdRef.current) return customerIdRef.current; // Avoid re-fetching if already stored

    try {
      const data = await fetchOnlyData("customers/default-customer");
      customerIdRef.current = data?.id ?? null; // Store in ref
      return customerIdRef.current;
    } catch (error) {
      console.error("Error fetching default customer:", error);
      return null;
    }
  };

  // React Query for initial fetch
  const { data } = useQuery({
    queryKey: ["defaultCustomer"],
    queryFn: fetchDefaultCustomer, // Call manually
    staleTime: 1000 * 60 * 50, // Keep fresh for 50 minutes
    cacheTime: 1000 * 60 * 60, // Cache for 60 minutes
    retry: 1,
    keepPreviousData: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    select: (data) => {
      if (data) customerIdRef.current = data; // Store in ref
      return data;
    },
  });

  // UseEffect to ensure it’s only set once
  useEffect(() => {
    if (data && !customerIdRef.current) {
      customerIdRef.current = data;
    }
  }, [data]);

  return customerIdRef.current; // Return stored value, preventing re-renders
}

export default useDefaultCustomer;
